/**
 * Author: Nigel Leck
 */
import 'whatwg-fetch';
import 'url-search-params-polyfill';
const awsconfig = require('@/aws-exports.json');

export function findService( result)
{
    let authSeNumber=document.getElementById('authSeNumber').value;
    let seNumber="SE-" + "00000000".substring(1, 9 - authSeNumber.length ) + authSeNumber;

    let p = new Promise(
        function( resolve, reject){
            if( !result)
            {
                reject( {message: "validation failed"});
            }
            else
            {
                doSearch(seNumber, resolve, reject);
            }
        }
    );
    
    return p;
}

export function linkService( seNumber)
{
    let p = new Promise(
        function( resolve, reject){
            if( !seNumber)
            {
                reject( {message: "Invalid SE Number",navigate:"auth-register"});
            }
            else
            {
                doLink(seNumber, resolve, reject);
            }
        }
    );
    
    return p;
}

export async function serviceCall(  serviceName, options)
{
    // const authUser = store.getters.authUser;
    // if(authUser.exp < (Date.parse(new Date()) / 1000)) {
    //     Auth.logout();
    //     throw {
    //         code: "NoSuchService",
    //         message: "Your session has expired. You will be logged out."
    //     }
    // }

    let headers={};
    // console.log( "awsconfig.API",awsconfig.API);
    if( awsconfig.API.headers){
        Object.assign(headers, awsconfig.API.headers);
    }
 
    let item=awsconfig.API.endpoints.find( item => {
        return item.name === serviceName;
    } );

    if( !item)
    {
        throw {
            code: "NoSuchService",
            message: "No such service: " + serviceName
        }
    }
    // console.log( "item",item);
    if( item && item.headers){
        Object.assign(headers, item.headers);
    }

    let callOptions={
        // mode: 'cors',
        // credentials:'include'
    };
    if( options)
    {
        Object.assign( callOptions, options);
        // console.log( "options",options);
        if( options.headers)
        {
            Object.assign( headers, options.headers);
        }
    }

    // console.log( "callOptions",callOptions);
    callOptions.headers=headers;

    // let url=item.endpoint;
    let url=window.config.VUE_APP_API;
    
    if( !callOptions.path && item.path)
    {
        callOptions.path=item.path;
    }
    if( callOptions.path)
    {
        if( !callOptions.path.startsWith("/"))
        {
            url +="/";
        }
        url += callOptions.path;
        delete callOptions.path;
    }

    if( item.searchParams)
    {
        let tmpSearchParams={};
        Object.assign( tmpSearchParams, item.searchParams);
        if( options.searchParams)
        {
            Object.assign( tmpSearchParams, options.searchParams);
        }
        callOptions.searchParams=tmpSearchParams;
    }

    if( callOptions.searchParams){
        // console.log(callOptions.searchParams );
        let searchParams = new URLSearchParams();

        for( let key in callOptions.searchParams)
        {
            searchParams.append( key, callOptions.searchParams[key]);
        }

        if( url.includes( "?"))
        {
            url+="&";
        }
        else {
            url+="?";
        }

        url +=searchParams;

        delete callOptions.searchParams;
    }
    try{
        if( !callOptions.method)
        {
            callOptions.method='GET';
        }
        // console.log(url);
        // console.log(callOptions);
        const response = await fetch(url, callOptions);
        if (!response.ok) {
            return response.text().then(text => {

                if (text.startsWith("{") && text.endsWith("}")) {
                    throw JSON.parse(text);
                }
                throw Error(text);
            });
        }
        if (options.path === "/greenid") {
            const data = await response.json();
            return { ...data, statusCode: response.status };
        }
        return await response.json();
        }
        catch( e)
        {
            let p = new Promise( function( resolve, reject){
                reject( e);
                
            });

            return p;
        }
} 

async function doSearch( seNumber, resolve, reject)
{
    serviceCall(
        "register",{
            'searchParams': {
                'seNumber': seNumber
            }
        }
    )
    .then(
        response => {
            // console.log( response);
            let users=response.Users;
            if( !users || users.length != 1)
            {
				throw {
					code: "UserNotFoundException",
					message: "User does not exist."
				};
               
            }
            else
            {
                resolve( users[0]);
            }
        }
    ).catch( err => reject( err));
}

async function doLink( seNumber, resolve, reject)
{
    serviceCall(
        "register",{
            // path: "/link",
            method: 'POST',
            searchParams: {
                seNumber: seNumber
            }
        }
    )
    .then(
        response => {
            // console.log( response);
        
            if( response.User)
            {
                resolve( response.User);
            }
            else
            {
                reject( response);
            }
        }
    ).catch( err => reject( err));
}